// extracted by mini-css-extract-plugin
export default {"empty-state":"_3N47Y","emptyState":"_3N47Y"};